export enum Breakpoints {
  XS = 320,
  SM = 768,
  MD = 992,
  LG = 1200,
  XL = 1920 - 16,
}

export enum EInterval {
  URGENT = 5000,
  URGENT_FEEDBACK = 5000,
  NOTIFICATION = 3000,
  TAB_NOTIFICATION = 2000,
}
